module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//22.jpg?2252c55eb9f3de7af90710385efed6a8";